import { isObject } from 'radash'
import app from '@/main.js'

async function validateForm (formSchema, formValues) {
  const formErrors = {}

  try {
    await formSchema.validate(formValues, {
      abortEarly: false
    })
  } catch (error) {
    for (const item of error.inner) {
      if (!item.path) {
        continue
      }

      if (isObject(item.message) && item.message.key) {
        formErrors[item.path] = app.$i18n.t(item.message.key)
      } else {
        formErrors[item.path] = item.message
      }
    }

    throw formErrors
  }
}

export default validateForm
